/* CELESTIAR — gift.js : partage d'un ciel (lien cadeau) + pré-remplissage du configurateur */
(function () {
  "use strict";
  var I18N = window.CELESTIAR_I18N || {};
  var LOCALE = I18N.locale === 'en' ? 'en-GB' : 'fr-FR';

  var PARAMS = ["prenom", "date", "heure", "ville", "phrase"];

  function readParams() {
    try { return new URLSearchParams(window.location.search); } catch (e) { return { get: function () { return null; } }; }
  }

  /* ---------- Pré-remplissage du configurateur produit ---------- */
  var form = document.querySelector("form.product-form, [data-product-form]");
  if (form) {
    document.addEventListener("DOMContentLoaded", function () {
      /* Apres l'init de product-form.js (ordre des scripts) : valeurs + evenements */
      var q = readParams();
      var filled = false;
      var map = { prenom: "prenom", date: "date", heure: "heure", ville: "ville", phrase: "message" };
      Object.keys(map).forEach(function (key) {
        var v = q.get(key);
        var input = document.querySelector('[data-testid="ic-' + map[key] + '-input"]');
        if (v && input) { input.value = v; input.dispatchEvent(new Event("input", { bubbles: true })); filled = true; }
      });
      if (filled && (q.get("de") || q.get("msg"))) {
        var note = document.createElement("p");
        note.className = "gift-prefill-note";
        note.textContent = I18N.prefill_note || "✦ Un ciel a été préparé pour vous — tout est déjà rempli.";
        var first = form.querySelector(".field");
        if (first && first.parentElement) first.parentElement.insertBefore(note, first);
      }
    });
  }

  /* ---------- Reporter la personnalisation en changeant d'affiche ---------- */
  if (form) {
    document.querySelectorAll(".poster-thumb[href*='/products/']").forEach(function (a) {
      a.addEventListener("click", function () {
        var get = function (t) { var el = document.querySelector('[data-testid="ic-' + t + '-input"]'); return el ? el.value : ""; };
        var p = new URLSearchParams();
        if (get("prenom")) p.set("prenom", get("prenom"));
        if (get("date")) p.set("date", get("date"));
        if (get("heure")) p.set("heure", get("heure"));
        if (get("ville")) p.set("ville", get("ville"));
        if (get("message")) p.set("phrase", get("message"));
        var qs = p.toString();
        if (qs) a.href = a.href.split("?")[0] + "?" + qs;
      });
    });
  }

  /* ---------- Modale de partage ---------- */
  var modal = document.querySelector("[data-gift-modal]");
  var closeModal = function () { if (modal) modal.classList.remove("is-open"); };
  document.querySelectorAll("[data-gift-open]").forEach(function (b) {
    b.addEventListener("click", function () { if (modal) modal.classList.add("is-open"); });
  });
  document.querySelectorAll("[data-gift-close]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); closeModal(); });
  });
  if (modal) modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });

  var copyBtn = document.querySelector("[data-gift-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var val = function (sel) { var el = document.querySelector(sel); return el ? el.value : ""; };
      var prodPath = (window.location.pathname.match(/\/products\/[a-z0-9-]+/i) || [""])[0];
      var url = window.location.origin + ((window.CELESTIAR_I18N||{}).root||"/").replace(/\/$/,"") + "/pages/cadeau" +
        "?produit=" + encodeURIComponent(prodPath) +
        "&prenom=" + encodeURIComponent(val('[data-testid="ic-prenom-input"]')) +
        "&date=" + encodeURIComponent(val('[data-testid="ic-date-input"]')) +
        "&heure=" + encodeURIComponent(val('[data-testid="ic-heure-input"]')) +
        "&ville=" + encodeURIComponent(val('[data-testid="ic-ville-input"]')) +
        "&phrase=" + encodeURIComponent(val('[data-testid="ic-message-input"]')) +
        "&msg=" + encodeURIComponent(val("[data-gift-msg-input]")) +
        "&de=" + encodeURIComponent(val("[data-gift-from-input]"));
      var done = function () {
        closeModal();
        var toast = document.createElement("div");
        toast.className = "gift-toast";
        toast.textContent = I18N.gift_toast || "Lien cadeau copié — prêt à être offert";
        document.body.appendChild(toast);
        requestAnimationFrame(function () { toast.classList.add("is-visible"); });
        setTimeout(function () { toast.classList.remove("is-visible"); setTimeout(function () { toast.remove(); }, 500); }, 3200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt(I18N.prompt_copy || "Copiez ce lien :", url); });
      } else {
        window.prompt(I18N.prompt_copy || "Copiez ce lien :", url);
      }
    });
  }

  /* ---------- Page cadeau : remplit les champs depuis l'URL ---------- */
  var giftRoot = document.querySelector("[data-gift-page]");
  if (giftRoot) {
    var gq = readParams();
    var set = function (sel, v) { var el = giftRoot.querySelector(sel); if (el && v) el.textContent = v; };
    set("[data-gift-from]", gq.get("de"));
    set("[data-gift-msg]", gq.get("msg") ? "« " + gq.get("msg") + " »" : null);
    set("[data-gift-prenom]", gq.get("prenom"));
    var bits = [];
    if (gq.get("ville")) bits.push(gq.get("ville"));
    if (gq.get("date")) {
      var d = new Date(gq.get("date") + "T00:00:00");
      bits.push(isNaN(d) ? gq.get("date") : d.toLocaleDateString(LOCALE, { day: "numeric", month: "long", year: "numeric" }));
    }
    if (gq.get("heure")) bits.push(gq.get("heure"));
    set("[data-gift-recap]", bits.join(" · "));
    set("[data-gift-phrase]", gq.get("phrase") ? "« " + gq.get("phrase") + " »" : null);
    var cta = giftRoot.querySelector("[data-gift-cta]");
    if (cta) {
      var params = new URLSearchParams();
      PARAMS.forEach(function (k) { if (gq.get(k)) params.set(k, gq.get(k)); });
      /* le lien cadeau utilise « msg » : on le traduit en « phrase » pour le configurateur */
      if (!gq.get("phrase") && gq.get("msg")) params.set("phrase", gq.get("msg"));
      var root = ((window.CELESTIAR_I18N || {}).root || "/").replace(/\/$/, "");
      var base = gq.get("produit") || "/products/aurore-boreale";
      /* sécurité : seul un chemin /products/... du site est accepté */
      base = (/^\/(en\/)?products\/[a-z0-9-]+$/i.test(base) ? base.replace(/^\/en(?=\/)/, "") : "/products/aurore-boreale");
      var qs = params.toString();
      cta.setAttribute("href", root + base + (qs ? "?" + qs : ""));
    }
  }
})();
